import { PartnerType } from "@tm/isomorphic-utils";
import React, { createContext, useContext } from "react";

const PartnerContext = createContext<PartnerType | null>(null);

export const usePartnerContext = () => {
  const context = useContext(PartnerContext);
  if (context === null) {
    console.error(
      "usePartnerContext must be used within a PartnerContextProvider"
    );
  }
  return context;
};

export const PartnerContextProvider: React.FC<{
  hostname?: string;
  children: React.ReactNode;
  partnerType?: any;
}> = ({ hostname, children, partnerType }) => {
  return (
    <PartnerContext.Provider value={partnerType}>
      {children}
    </PartnerContext.Provider>
  );
};
